/** Is this session hosted by the Teacher Computer app (the local sidecar), as opposed to the
 * cloud? The sidecar says so itself on `/v1/host/info` (`local: true`, credential-free); on a
 * real server the route does not exist and the answer is no. The request is the one
 * `platform/joinOrigin.ts` already makes for the address a phone can reach, cached there, so
 * the page asks once. The live view needs the fact for one line: a local host has no
 * internet, so a chat channel that answers over the internet is off in that lesson (FR-056)
 * and the app must never claim otherwise.
 */
import { useEffect, useState } from "react";

import { hostInfo } from "../platform/joinOrigin";

/** True once the host has answered that it is the local one; false until then and elsewhere. */
export function useLocalHost(): boolean {
  const [local, setLocal] = useState(false);
  useEffect(() => {
    let live = true;
    void hostInfo().then((info) => {
      if (live) setLocal(info?.local === true);
    });
    return () => {
      live = false;
    };
  }, []);
  return local;
}
